import React, { useEffect, useRef, useState } from "react";
import PointStartIcon from "../../../shared/icons/PointStartIcon.svg";
import PointFinishIcon from "../../../shared/icons/PointFinishIcon.svg";
import TruckIcon from "../../../shared/icons/TruckIcon.svg";
import MarkerIcon from "../../../shared/icons/MarkerIcon.svg";
import { MapsData } from "../../../../services";
import Loading from "../../../shared/Loading/Loading";

const YandexMap = ({
  item,
  cityFrom,
  cityTo,
  routeData,
  isLoadingMap,
  coordinateTruck,
  addressList,
}) => {
  const mapRef = useRef(null);
  const YANDEX_API_KEY = process.env.REACT_APP_YMAPS_API_KEY;

  useEffect(() => {
    const loadYandexMaps = () => {
      if (window.ymaps) {
        window.ymaps.ready(initMap);
      } else {
        const script = document.createElement("script");
        script.src = `https://api-maps.yandex.ru/2.1/?apikey=${YANDEX_API_KEY}&lang=ru_RU`;

        script.onload = () => {
          if (window.ymaps) {
            window.ymaps.ready(initMap);
          }
        };
        document.body.appendChild(script);
      }
    };

    const applyCustomStyles = (mapContainer) => {
      const routeButton = mapContainer.querySelector(".ymaps-2-1-79-route-panel__logo");
      if (routeButton) {
        routeButton.style.display = "none";
      }

      const routeContainerBtn = mapContainer.querySelector(
        ".ymaps-2-1-79-map-copyrights-promo",
      );
      if (routeContainerBtn) {
        routeContainerBtn.style.display = "none";
      }

      const innerPanes = document.querySelector(".ymaps-2-1-79-inner-panes");
      if (innerPanes) {
        innerPanes.style.borderRadius = "16px";
      }

      const mapBg = document.querySelector(".ymaps-2-1-79-map-bg");
      if (mapBg) {
        mapBg.style.backgroundImage = "none";
      }
    };

    const initMap = () => {
      if (!mapRef.current) return;

      const map = new window.ymaps.Map(mapRef.current, {
        center: [50.813, 71.906],
        zoom: 5,
        controls: ["zoomControl"],
      });

      map.controls.remove("geolocationControl");
      map.controls.remove("trafficControl");
      map.controls.remove("typeSelector");
      map.controls.remove("fullscreenControl");
      map.controls.remove("rulerControl");
      map.controls.remove("searchControl");

      const mapContainer = map.container.getElement();
      applyCustomStyles(mapContainer);

      if (coordinateTruck.length > 0) {
        const routeCoordinates = coordinateTruck.map((coord) => [coord.lat, coord.lng]);
        const routeLine = new window.ymaps.Polyline(
          routeCoordinates,
          {},
          {
            strokeColor: "#000000",
            strokeWidth: 2,
            strokeStyle: "2 2",
          },
        );
        map.geoObjects.add(routeLine);

        const startPlacemark = new window.ymaps.Placemark(
          [cityFrom.latitude, cityFrom.longitude],
          {},
          {
            iconLayout: "default#image",
            iconImageHref: PointStartIcon,
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42],
          },
        );
        map.geoObjects.add(startPlacemark);

        const finishPlacemark = new window.ymaps.Placemark(
          [cityTo.latitude, cityTo.longitude],
          {},
          {
            iconLayout: "default#image",
            iconImageHref: PointFinishIcon,
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42],
          },
        );
        map.geoObjects.add(finishPlacemark);

        const lastPoint = coordinateTruck[coordinateTruck.length - 1];
        const truckPlacemark = new window.ymaps.Placemark(
          [lastPoint.lat, lastPoint.lng],
          {
            hintContent: `Дата: ${lastPoint.date}`,
          },
          {
            iconLayout: "default#image",
            iconImageHref: TruckIcon,
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -21],
          },
        );
        map.geoObjects.add(truckPlacemark);

        const bounds = window.ymaps
          .geoQuery([
            startPlacemark,
            finishPlacemark,
            ...routeCoordinates.map((coords) => new window.ymaps.Placemark(coords)),
          ])
          .getBounds();
        if (bounds) {
          map.setBounds(bounds, {
            checkZoomRange: true,
            duration: 500,
          });
        }
      } else if (
        !isLoadingMap &&
        addressList.length > 2 &&
        addressList.every((point) => point.latLng)
      ) {
        const referencePoints = [...addressList.map((point) => point.latLng)];

        const multiRoute = new window.ymaps.multiRouter.MultiRoute(
          {
            referencePoints,
            params: { routingMode: "truck" },
          },
          {
            boundsAutoApply: true,
            wayPointStartIconLayout: "default#image",
            wayPointFinishIconLayout: "default#image",
            wayPointStartIconImageHref: PointStartIcon,
            wayPointFinishIconImageHref: PointFinishIcon,
            wayPointStartIconImageSize: [30, 42],
            wayPointStartIconImageOffset: [-15, -42],
            wayPointFinishIconImageSize: [30, 42],
            wayPointFinishIconImageOffset: [-15, -42],
            routeStrokeWidth: 2,
            routeActiveStrokeWidth: 4,
            routeActiveStrokeColor: "#0000FF",
          },
        );

        map.geoObjects.add(multiRoute);
      } else if (routeData) {
        const savedRoute = new window.ymaps.Polyline(
          routeData,
          {},
          {
            strokeColor: "#C5115E",
            strokeWidth: 3,
          },
        );
        map.geoObjects.add(savedRoute);

        const startPlacemark = new window.ymaps.Placemark(
          routeData[0],
          {},
          {
            iconLayout: "default#image",
            iconImageHref: PointStartIcon,
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42],
          },
        );
        const finishPlacemark = new window.ymaps.Placemark(
          routeData[routeData.length - 1],
          {},
          {
            iconLayout: "default#image",
            iconImageHref: PointFinishIcon,
            iconImageSize: [30, 42],
            iconImageOffset: [-15, -42],
          },
        );
        map.geoObjects.add(startPlacemark);
        map.geoObjects.add(finishPlacemark);

        const routeBounds = savedRoute.geometry.getBounds();
        if (routeBounds) {
          map.setBounds(routeBounds, {
            checkZoomRange: true,
            duration: 500,
          });
        }
      } else {
        const multiRoute = new window.ymaps.multiRouter.MultiRoute(
          {
            referencePoints: [
              [cityFrom.latitude, cityFrom.longitude],
              [cityTo.latitude, cityTo.longitude],
            ],
            params: {
              routingMode: "auto",
              routingMode: "truck",
              truckWeight: 10000,
            },
          },
          {
            boundsAutoApply: true,
            wayPointStartIconLayout: "default#image",
            wayPointFinishIconLayout: "default#image",
            wayPointStartIconImageHref: PointStartIcon,
            wayPointFinishIconImageHref: PointFinishIcon,
            wayPointStartIconImageSize: [30, 42],
            wayPointStartIconImageOffset: [-15, -42],
            wayPointFinishIconImageSize: [30, 42],
            wayPointFinishIconImageOffset: [-15, -42],
            routeStrokeWidth: 2,
            routeActiveStrokeWidth: 4,
            routeActiveStrokeColor: "#0000FF",
          },
        );

        multiRoute.events.add("update", function () {
          const mapContainer = map.container.getElement();
          const routeButton = mapContainer.querySelector(
            ".ymaps-2-1-79-route-panel__logo",
          );
          if (routeButton) {
            routeButton.style.display = "none";
          }

          const routeContainerBtn = mapContainer.querySelector(
            ".ymaps-2-1-79-map-copyrights-promo",
          );
          if (routeContainerBtn) {
            routeContainerBtn.style.display = "none";
          }

          const innerPanes = document.querySelector(".ymaps-2-1-79-inner-panes");
          if (innerPanes) {
            innerPanes.style.borderRadius = "16px";
          }

          const mapBg = document.querySelector(".ymaps-2-1-79-map-bg");
          if (mapBg) {
            mapBg.style.backgroundImage = "none";
          }
        });

        map.geoObjects.add(multiRoute);

        multiRoute.model.events.add("requestsuccess", function () {
          const activeRoute = multiRoute.getActiveRoute();
          if (activeRoute) {
            const distance = activeRoute.properties.get("distance").value;
            const duration = activeRoute.properties.get("duration").value;

            const distanceInKm = (distance / 1000).toFixed(2);
            const formatDuration = (duration) => {
              const hours = Math.floor(duration / 3600).toString().padStart(2, '0');
              const minutes = Math.ceil((duration % 3600) / 60).toString().padStart(2, '0');
              return `${hours}:${minutes}`;
            };
            const routePaths = activeRoute
              .getPaths()
              .toArray()
              .map((path) => path.getSegments().toArray());
            const routeCoordinates = routePaths
              .flat(2)
              .map((segment) => segment.geometry.getCoordinates());
            const flattenedCoordinates = routeCoordinates.flat();

            const data = {
              fromCityId: item.cityIdFrom,
              toCityId: item.cityIdTo,
              jsonData: JSON.stringify(flattenedCoordinates),
              distance: distanceInKm,
              totalTime: formatDuration(duration),
            };

            MapsData.sendRoute(data);
          }
        });
      }
    };

    loadYandexMaps();
  }, [routeData]);

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {isLoadingMap ? (
        <Loading height="80vh" borderRadius="16px" />
      ) : (
        <div ref={mapRef} style={{ width: "100%", height: "100%" }} />
      )}
    </div>
  );
};

export default YandexMap;
